import React from 'react';
import CurrentSiteContext from 'modules/react/contexts/CurrentSiteContext';
import Translation from '../../../website/components/stateless/Translation';

export function formatLabel(id, defaultMessage) {
  return (
    <CurrentSiteContext.Consumer>
      {({ theme }) => {
        const { fonts: { primary } } = theme;
        return (
          <h5 style={{ display: 'inline', fontFamily: primary.name }}>
            <Translation id={id} defaultMessage={defaultMessage} />
          </h5>
        );
      }}
    </CurrentSiteContext.Consumer>
  );
}
